import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../../components/CalendlyFab';

const KlassiTechDevelopment = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">Software Development</h1>
          <p className="lead text-warning fw-bold">Custom Software Solutions for Your Business</p>
          <Link to="/klassitech">
            <Button variant="outline-warning" className="mt-3">
              <i className="bi bi-arrow-left me-2"></i>
              Back to KlassiTech
            </Button>
          </Link>
        </div>

        <Row className="g-4 mb-5">
          <Col xs={12} md={6} lg={4} className="text-center">
            <Link to="/klassitech/development" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/webDevelopment.png"
                  alt="Web Development"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Web Development</h3>
              <p className="text-light-50">
                Modern web applications built with cutting-edge technologies.
                Responsive, scalable, and user-friendly solutions.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="text-center">
            <Link to="/klassitech/development" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/mobileDevelopment.png"
                  alt="Mobile Development"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Mobile Development</h3>
              <p className="text-light-50">
                Native and cross-platform mobile applications.
                Deliver exceptional user experiences across all devices.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={4} className="text-center">
            <Link to="/klassitech/development" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/images/enterpriseSolution.png"
                  alt="Enterprise Solutions"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Enterprise Solutions</h3>
              <p className="text-light-50">
                Scalable enterprise-grade software systems.
                Streamline operations and drive business growth.
              </p>
            </Link>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Our Development Process</h2>
              <ul className="text-primary">
                <li className="mb-2">Agile methodology for flexible development</li>
                <li className="mb-2">Regular client collaboration and feedback</li>
                <li className="mb-2">Continuous integration and deployment</li>
                <li className="mb-2">Comprehensive testing and quality assurance</li>
                <li className="mb-2">Ongoing support and maintenance</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Technologies We Use</h2>
              <p className="text-primary mb-4">
                We work with a wide range of modern technologies:
              </p>
              <div className="row">
                <div className="col-6">
                  <ul className="text-primary">
                    <li className="mb-2">React & Node.js</li>
                    <li className="mb-2">Python & Django</li>
                    <li className="mb-2">Java & Spring</li>
                  </ul>
                </div>
                <div className="col-6">
                  <ul className="text-primary">
                    <li className="mb-2">AWS & Azure</li>
                    <li className="mb-2">Docker & Kubernetes</li>
                    <li className="mb-2">MongoDB & PostgreSQL</li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="mt-5">
          <div className="bg-dark p-4 rounded shadow mb-4">
            <h3 className="text-light text-center mb-3">Development in Action</h3>
            <div className="text-center">
              <img 
                src="/images/developmentInAction.png"
                alt="Development Solution Diagram"
                className="img-fluid rounded"
                style={{ 
                  maxWidth: '80%',
                  width: '600px',
                  height: 'auto',
                  border: '3px solid #FFD700',
                  borderRadius: '15px',
                  margin: '0 auto'
                }}
              />
              <p className="text-primary mt-2 mb-0">
                Our development process blends agile methodologies with cutting-edge technologies to deliver software that is not only robust and scalable but also easy to maintain and evolve. By embracing iterative development, continuous feedback, and cross-functional collaboration, we ensure that every solution we build aligns with your business goals and adapts to change with ease. Whether it's a startup MVP or an enterprise-grade platform, we deliver high-quality code that performs — now and in the future.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <Link to="/klassitech" className="btn btn-outline-warning">
            <i className="bi bi-arrow-left me-2"></i>
            Back to KlassiTech
          </Link>
        </div>

        <CalendlyFab />
      </Container>
    </div>
  );
};

export default KlassiTechDevelopment; 